import React, { useState } from 'react'
import { useDataUsuarioSelected } from '../../../../Hooks/Admin/useContextos';
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { usePokedexUsuarioTable, useCrearPokedexUsuario, useEditarPokedexUsuario, useEliminarPokedexUsuario } from '../queries/querysPokedex';
import { useFormularioPokedex } from './Hooks/Pokedex/useFormularioPokedex';
import { Card } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useQueryClient } from 'react-query';
import { PokedexEditForm } from './PokedexEditForm';

export const PokedexUsuario = () => {
  const { selectedId } = useDataUsuarioSelected();
  const queryClient = useQueryClient();

  const {
    columnas,
    camposFormulario,
    camposFormularioCrear,
  } = useFormularioPokedex();

  // Estado para el modal de edición controlado manualmente
  const [editingRecord, setEditingRecord] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const handleOpenEdit = (row) => {
    setEditingRecord(row);
    setIsEditOpen(true);
  };

  const handleCloseEdit = () => {
    setIsEditOpen(false);
    setEditingRecord(null);
  };

  const mutationEditar = useEditarPokedexUsuario();

  const handleSubmitEdit = (values) => {
    mutationEditar.mutateAsync(values)
      .then(() => {
        handleCloseEdit();
        queryClient.invalidateQueries(["pokedexUsuarioTable"]);
      })
      .catch(() => {
        // Errores ya manejados por el hook (notification.error)
      });
  };

  const accionesList = () => [
    {
      label: "Editar",
      key: "editar",
      icon: <EditOutlined />,
      onClick: (row) => handleOpenEdit(row),
    },
  ];

  if (!selectedId) {
    return <Card title="Elije un usuario para poder interactuar con esta pestaña" />;
  }

  return (
    <>
      <CustomTable
        columns={columnas}
        perPage={10}
        queryListar={usePokedexUsuarioTable}
        basicParams={{ usua_id: selectedId, page: 1, perPage: 10 }}
        externalParams={{ usua_id: selectedId }}
        camposFilter={camposFormulario}
        camposAgregar={camposFormularioCrear(selectedId)}
        queryCrear={useCrearPokedexUsuario}
        accionesList={accionesList()}
        onClickActions={(row) => handleOpenEdit(row)}
        canDelete={true}
        queryBorrarFila={useEliminarPokedexUsuario}
      />
      <PokedexEditForm
        open={isEditOpen}
        record={editingRecord}
        onCancel={handleCloseEdit}
        onSubmit={handleSubmitEdit}
      />
    </>
  );
};
